//金山圈路由
export default
    {
        path: "/kscircle",
        component: () => import('../view/kscircle/index.vue'),
        children: [
            {
                path: "kscircleMain",//金山圈主页面
                name: 'kscircleMain',//金山圈主页面
                component: () => import('../view/kscircle/kscircleMain.vue'),//金山圈主页面
                children:[
                    {
                        path: "release",
                        name: "release",
                        component: () => import('../view/kscircle/release.vue'),
                    }
                ]

            },
            {
                path: "kscircleAuthor",//金山圈授权
                name: 'kscircleAuthor',//金山圈授权
                component: () => import('../view/kscircle/kscircleAuthor.vue'),
                props: (route) => (
                    {
                        token:route.query.token,
                        koaToken:route.query.koaToken,
                        userId:route.query.userId,
                        deviceType:route.query.deviceType
                        
                    }
                ),

            },
        ]

    }



// WEBPACK FOOTER //
// ./src/router/kscircleRouter.js